export interface CoreApiConfig {
  protocol: string;
  host: string;
}

export interface AppConfig {
  coreApi: CoreApiConfig;
}

let config: AppConfig;

if (process.env.REACT_APP_ENV === "dev") {
  config = require("./dev").config;
} else if (process.env.REACT_APP_ENV === "staging") {
  config = require("./staging").config;
} else if (process.env.REACT_APP_ENV === "production") {
  config = require("./production").config;
} else {
  config = require("./local").config;
}

export default config;
